import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/gossip';

export default function Footer() {
  return (
    <footer className="bg-background-200/50 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="rounded-2xl bg-background-100 p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
              <div className="md:col-span-4">
                <Link to="/" className="flex items-center gap-2 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                    <i className="ri-spy-line text-background-50 text-lg"></i>
                  </div>
                  <span className="text-xl font-bold text-foreground-900 font-heading">
                    吃瓜网
                  </span>
                </Link>
                <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
                  吃瓜网入口实时追踪全网最劲爆内幕，明星塌房与网红反差视频凌晨流出直达。深扒娱乐圈不雅八卦，热门大瓜聊天记录全网首发，精彩猛料持续更新中。
                </p>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                  吃瓜分类
                </h4>
                <ul className="space-y-2.5">
                  {footerLinks.categories.map((link) => (
                    <li key={link.slug}>
                      <Link
                        to={`/category/${link.slug}`}
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                  快速入口
                </h4>
                <ul className="space-y-2.5">
                  {footerLinks.quickLinks.map((link) => (
                    <li key={link.slug}>
                      <Link
                        to={`/${link.slug}`}
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                  法律信息
                </h4>
                <ul className="space-y-2.5">
                  {footerLinks.legal.map((link) => (
                    <li key={link.slug}>
                      <Link
                        to={`/${link.slug}`}
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                  关注我们
                </h4>
                <div className="flex gap-3">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-sm"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-sm"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="抖音">
                    <i className="ri-tiktok-line text-sm"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 吃瓜网 lrayneca.cn 版权所有
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                {footerLinks.legal.map((link, i) => (
                  <span key={link.slug} className="flex items-center gap-4">
                    {i > 0 && <span className="text-foreground-300">|</span>}
                    <Link to={`/${link.slug}`} className="hover:text-foreground-700 transition-colors">
                      {link.name}
                    </Link>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
